import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, HostListener, HostBinding } from '@angular/core';
import { PreviewMode } from '../../../model/preview-mode';
import { UiIconModel } from '@local/ui-infra';
import { ErrorType } from '@shared/services/stream-content.service';

@Component({
  selector: 'error-preview',
  templateUrl: 'error-preview.component.html',
  styleUrls: ['./error-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPreviewComponent {
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.stopPropagation();
  }
  @HostBinding('style.cursor')
  get cursor(): string {
    return 'default';
  }

  @Input() errorType: ErrorType;
  @Input() previewMode: PreviewMode;
  @Input() icon: UiIconModel;
  @Output() reload = new EventEmitter();
  @Output() download = new EventEmitter();
  @Output() open = new EventEmitter();
}
